import { TableColumnsType } from 'antd';
import { styled } from 'styled-components';
import { DiffRevenueInfo } from './DiffRevenueInfo';
import { flexMixin } from '@styles/mixins';
import {
    IAverageCheckByDays,
    ICountChecksByDays,
    IRevenueByDays,
} from '@entities/reports';
import { formatNumberWithDot } from '@utils/functions/formatNumberWithDot';

interface ReportColumnProps {
    title: string;
    columns: string[] | undefined;
}

export const createReportColumns = ({
    title,
}: ReportColumnProps): TableColumnsType<
    IRevenueByDays | ICountChecksByDays | IAverageCheckByDays
> => [
    {
        title: 'Ресторан(ы)',
        width: 'auto',
        dataIndex: 'key',
        align: 'left',
        responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
    },
    {
        title,
        dataIndex: title,
        width: '25%',
        responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
        align: 'right',
        render: value => (
            <StyledSum>
                {title !== 'Кол-во чеков за период'
                    ? formatNumberWithDot(value)
                    : `${value} шт`}
            </StyledSum>
        ),
    },
    {
        title: 'За предыдущий период',
        width: '25%',
        dataIndex: 'За предыдущий период',
        responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
        align: 'right',
        render: value => (
            <StyledSum>
                {title !== 'Кол-во чеков за период'
                    ? formatNumberWithDot(value)
                    : `${value} шт`}
            </StyledSum>
        ),
    },
    {
        title: 'Динамика',
        width: '25%',
        dataIndex: 'Динамика',
        responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
        align: 'right',

        render: value => (
            <DiffWrapper>
                <DiffRevenueInfo diff={value} />
            </DiffWrapper>
        ),
    },
];

const StyledSum = styled.div`
    text-align: right;
    padding-right: 0.5em;
`;

const DiffWrapper = styled.div`
    width: 100%;
    ${flexMixin('row', 'flex-end', 'center')};
    padding-right: 0.5em;
`;
